import SectionHeading from "@/pages/home/components/SectionHeading";
import { tvSeries } from "@/mocks/home";

export default function TvSection() {
  return (
    <section id="tv" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="电视剧"
          tone="secondary"
          title="国产剧与海外剧，按追剧节奏来挑"
          desc="从迷你剧到长篇单元剧，这一区按篇幅和题材分组。集数少的适合一个周末刷完，长篇则更适合慢慢追。"
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {tvSeries.map((show) => (
            <article
              key={show.id}
              className="flex gap-4 md:gap-5 rounded-lg border border-background-200/80 bg-background-100/60 p-4 md:p-5 transition-colors duration-300 hover:border-secondary-300"
            >
              <div className="w-24 sm:w-28 md:w-32 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
                <img
                  src={show.poster}
                  alt={`${show.title} 剧集海报`}
                  title={`${show.title} 电视剧片单`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex flex-col">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    {show.title}
                  </h3>
                  <span className="inline-flex items-center gap-1 text-sm font-label font-semibold text-secondary-700 shrink-0">
                    <i className="ri-star-fill text-xs" />
                    {show.rating}
                  </span>
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500 font-label">
                  <span>{show.region}</span>
                  <span className="text-background-400">·</span>
                  <span>{show.year}</span>
                  <span className="text-background-400">·</span>
                  <span>{show.episodes}</span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {show.summary}
                </p>
                <span className="mt-3 self-start inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md bg-secondary-100 text-xs text-secondary-800 font-label">
                  <i className="ri-time-line" />
                  {show.episodes === "单元剧" ? "可拆开看" : "适合连续追"}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}